import { setDimension } from '../ga/helper'
import YQAD from './config/adapter'

let AD = {}

module.exports = function (carrierKey) {
  AD.divs = ['V6-Carriers-Main', 'V6-Carriers-Bottom']

  let googleAds = [
    {
      slotId: '/' + window.YQ.configs.adId + '/V6-Carriers-Main',
      divId: 'V6-Carriers-Main',
      interval: 30,
      mapping: [
        {
          viewSize: [768, 100],
          slotSize: [728, 90]
        },
        {
          viewSize: [468, 100],
          slotSize: [468, 60]
        },
        {
          viewSize: [320, 100],
          slotSize: [320, 50]
        },
        {
          viewSize: [0, 0],
          slotSize: []
        }
      ]
    },
    {
      slotId: '/' + window.YQ.configs.adId + '/V6-Carriers-Bottom',
      divId: 'V6-Carriers-Bottom',
      interval: 30,
      mapping: [
        {
          viewSize: [768, 100],
          slotSize: [728, 90]
        },
        {
          viewSize: [468, 100],
          slotSize: [468, 60]
        },
        {
          viewSize: [320, 100],
          slotSize: [320, 50]
        },
        {
          viewSize: [0, 0],
          slotSize: []
        }
      ]
    }
  ]

  let adsConfigs = [
    {
      type: 'google',
      percentage: 1
    }
  ]

  // 将对应divId进行赋值
  function setDivId(arrAds) {
    arrAds.forEach(function (item, index) {
      if (item.divId !== AD.divs[index]) {
        let divEl = document.getElementById(AD.divs[index])
        divEl?.setAttribute('id', item.divId)
      }
    })
  }

  YQAD &&
    YQAD.init(adsConfigs, {
      onGoogleLoad: function onGoogleLoad() {
        console.log('品牌标签详情页--加载了Google广告')

        setDivId(googleAds)

        YQAD.google.stopEvent()

        if (carrierKey == 0 || carrierKey) {
          YQAD.google.setTargeting('carrierId', String(carrierKey))
        }

        YQAD.google.initRefresh(googleAds)

        // 加载广告维度统计
        setDimension(6, 'google')
      }
    })
}
